// @flow
import React from "react";
import { compose } from "redux";
import styled from "styled-components";
import { withRouter } from "react-router-dom";
import { media } from "@nested/ui";
import { connect } from "react-redux";

import Logo from "./components/Logo";
import { Phone, OpenMenu } from "./components/Icons";
import { DesktopMenu, MobileMenu } from "./components/Menu";

const Wrapper = styled.header`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 99;
  height: 72px;
  padding-left: 10px;
  padding-right: 10px;

  background-color: ${({ white }) =>
    white ? "rgba(255,255,255,0.9)" : "transparent"};
  max-width: 1920px;

  ${media.tablet`
    padding-left: 35px;
    padding-right: 35px;
    height: 110px;
  `};
  margin: auto;
`;

const Nav = styled.nav`
  max-width: 1200px;
  margin: auto;

  input[type="checkbox"] {
    display: none;
  }

  input:checked + div {
    visibility: visible;
    opacity: 1;
    transform: none;
  }

  position: relative;
`;

const MobileButtons = styled.div`
  float: right;
  padding-top: 20px;
  padding-right: 10px;
  ${media.tablet`
    display: none;
  `};
`;

/**
 * The router subscribes to `pathname` in order to hide the mobile nav when
 * changing pages. Setting the hidden input's key prop to the pathname means
 * it will be remounted on every route change, resetting its state to unchecked
 * and hiding the nav.
 */
const mapStateToProps = (state) => ({
  navigationColour: state.navigation.colour,
});

const enhance = compose(
  withRouter,
  connect(mapStateToProps),
);

type Props = {
  location: {
    pathname: string,
  },
  navigationColour: string,
};

export function Navigation({
  location: { pathname },
  navigationColour,
}: Props) {
  return (
    <Wrapper white={navigationColour === "white"}>
      <Nav>
        <Logo />
        <MobileButtons>
          <Phone />
          <OpenMenu htmlFor="nav-toggle" />
        </MobileButtons>
        <input key={pathname} type="checkbox" id="nav-toggle" />
        <MobileMenu navigationColour={navigationColour} />
        <DesktopMenu navigationColour={navigationColour} />
      </Nav>
    </Wrapper>
  );
}

export default enhance(Navigation);
